import { AI_JOB_STATUSES, type AiJobStatus } from './job-status';

export const AI_JOB_TIMEOUT_MS = 15 * 60 * 1000;

export const AI_JOB_ACTIVE_TIMEOUT_STATUSES = [
  AI_JOB_STATUSES.CREATING,
  AI_JOB_STATUSES.RUNNING,
  AI_JOB_STATUSES.PENDING_OUTPUT,
] as const satisfies readonly AiJobStatus[];

export type AiJobTimeoutCandidate = {
  status: string;
  createdAt: Date;
  updatedAt: Date;
  startedAt: Date | null;
};

export function isAiJobActiveTimeoutStatus(
  status: string
): status is (typeof AI_JOB_ACTIVE_TIMEOUT_STATUSES)[number] {
  return AI_JOB_ACTIVE_TIMEOUT_STATUSES.some(
    (candidate) => candidate === status
  );
}

export function resolveAiJobTimeoutReference(
  job: AiJobTimeoutCandidate
): Date | null {
  if (job.status === AI_JOB_STATUSES.QUEUED) {
    return job.updatedAt ?? job.createdAt;
  }
  if (job.status === AI_JOB_STATUSES.RUNNING) {
    return job.startedAt ?? job.updatedAt ?? job.createdAt;
  }
  if (
    job.status === AI_JOB_STATUSES.CREATING ||
    job.status === AI_JOB_STATUSES.PENDING_OUTPUT
  ) {
    return job.updatedAt ?? job.createdAt;
  }
  return null;
}

export function isAiJobTimeoutEligible(
  job: AiJobTimeoutCandidate,
  now: Date
): boolean {
  const reference = resolveAiJobTimeoutReference(job);
  return (
    reference !== null &&
    now.getTime() - reference.getTime() >= AI_JOB_TIMEOUT_MS
  );
}
